<template>

  <tr class="hover:bg-gray-100">
    <td class="px-6 py-3 text-sm text-gray-500 text-left">
      <span class="lg:pl-2">{{ this.donation.fullName }}</span>
    </td>
    <td class="px-6 py-3 text-sm text-gray-500 text-left">
      {{ this.donation.amount }}
    </td>
    <td class="px-6 py-3 text-sm text-gray-500 text-left">
      {{ this.donation.campaign.name }}
    </td>
    <td class="px-6 py-3 text-sm text-gray-500 text-left">
      {{ this.donation.created_at }}
    </td>
  </tr>

</template>

<script>

export default {
  props: {
    donation: {},
  },
}
</script>
